'use strict';

const $ = window.jQuery;
import Parallax from 'parallax-js';

export default class Ball {
    constructor() {
        $('.ball-container__parallax').each(function () {
            const scene = $(this).get(0);
            new Parallax(scene);
        });
    }
}
